// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DatasetVersionUpdate
 */
export interface DatasetVersionUpdate {
  /**
   *
   */
  storeRef?: string | null;
  /**
   *
   */
  description?: string | null;
}

/**
 * Check if a given object implements the DatasetVersionUpdate interface.
 */
export function instanceOfDatasetVersionUpdate(value: object): value is DatasetVersionUpdate {
  return true;
}

export function DatasetVersionUpdateFromJSON(json: any): DatasetVersionUpdate {
  return DatasetVersionUpdateFromJSONTyped(json, false);
}

export function DatasetVersionUpdateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DatasetVersionUpdate {
  if (json == null) {
    return json;
  }
  return {
    storeRef:
      json["store_ref"] === undefined
        ? undefined
        : json["store_ref"] === null
        ? null
        : json["store_ref"],
    description:
      json["description"] === undefined
        ? undefined
        : json["description"] === null
        ? null
        : json["description"],
  };
}

export function DatasetVersionUpdateToJSON(json: any): DatasetVersionUpdate {
  return DatasetVersionUpdateToJSONTyped(json, false);
}

export function DatasetVersionUpdateToJSONTyped(
  value?: DatasetVersionUpdate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    store_ref: value["storeRef"],
    description: value["description"],
  };
}
